import React from "react";

export default function TapCard({ emoji, label, selected, onSelect, multiSelect }) {
  return (
    <button
      type="button"
      onClick={onSelect}
      style={{
        background: selected ? "rgba(255, 138, 0,0.07)" : "var(--surface, #fff)",
        border: `2px solid ${selected ? "var(--primary)" : "var(--border, #e5e7eb)"}`,
        borderRadius: "16px",
        padding: "20px 16px",
        textAlign: "center",
        minHeight: "80px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        cursor: "pointer",
        width: "100%",
        transition: "border-color 0.15s, background 0.15s",
      }}
    >
      {emoji && <span style={{ fontSize: "2rem", lineHeight: 1 }}>{emoji}</span>}
      <span style={{ fontWeight: selected ? 700 : 500, fontSize: "0.95rem", color: selected ? "var(--primary)" : "var(--text, #1C1C1E)", lineHeight: 1.3 }}>{label}</span>
      {multiSelect && selected && <span style={{ fontSize: "0.75rem", color: "var(--primary)" }}>✓ Selected</span>}
    </button>
  );
}
